import { createActions } from 'redux-actions';

export type ClaimQuickUpdatePayload = {
  claimableType: string;
  claimableId: number;
  status: string;
  totalClaimedAmount: number;
};

export type ClaimQuickUpdateSuccessPayload = {
  claimableType: string;
  claimableId: number;
};

export type ClaimQuickUpdateErrorPayload = {
  claimableType: string;
  claimableId: number;
};

export const { claimQuickUpdate, claimQuickUpdateSuccess, claimQuickUpdateError } = createActions(
  'CLAIM_QUICK_UPDATE',
  'CLAIM_QUICK_UPDATE_SUCCESS',
  'CLAIM_QUICK_UPDATE_ERROR',
  {
    prefix: 'USER_DASHBOARD_CLAIM_EDIT_MODAL',
  },
);
